export default "/images/d72e2e51d629d4e3bb22f5b6d507b1d9.avif";